import type React from 'react';
import SvgMaskIcon from '../SvgMaskIcon';

interface ExpandCenterIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const INNER =
    '<g fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<g transform="rotate(90, 12, 12)">' +
    '<polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/>' +
    '<line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>' +
    '</g></g>';

const ExpandCenterIcon: React.FC<ExpandCenterIconProps> = ({
    width = 20,
    height = 20,
    color = '#656565',
}) => <SvgMaskIcon viewBox="0 0 24 24" inner={INNER} width={width} height={height} color={color} />;

export default ExpandCenterIcon;
